export const SUPPORTED_DOCUMENT_HEADER_NAMES_TO_VALIDATION = [
  'borrower_drivers_license_name',
  'coborrower_drivers_license_name',
  'borrower_passport_name',
  'coborrower_passport_name',
  'borrower_green_card_name',
  'coborrower_green_card_name',
];
